var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path10, _path11, _path12, _path13, _rect2, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _path14, _rect3, _path15, _rect4, _rect5, _rect6, _path16, _path17, _path18, _path19, _path20, _path21, _rect7, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaceHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0mwh{fill:#282828;}\r\n\t.st1mwh{fill:#BCA94B;}\r\n\t.st2mwh{fill:#7A7A7A;}\r\n\t.st3mwh{fill:#BCA94C;}\r\n\t.st4mwh{fill:#2D2D2D;}\r\n\t.st5mwh{fill:#ADADAD;}\r\n\t.st6mwh{fill:#92918D;}\r\n\t.st7mwh{fill:#BCA94E;}\r\n\t.st8mwh{fill:#6E6E6D;}\r\n\t.st9mwh{fill:#7F7F80;}\r\n\t.st10mwh{fill:#8D8E8B;}\r\n\t.st11mwh{fill:#9E9E9E;}\r\n\t.st12mwh{fill:#262625;}\r\n\t.st13mwh{fill:#CEBC56;}\r\n\t.st14mwh{fill:#BCA94F;}\r\n\t.st15mwh{fill:#424242;}\r\n\t.st16mwh{fill:#4A4947;}\r\n\t.st17mwh{fill:#3F3F3F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0mwh",
    d: "M12.2,197c-0.3,0.9-0.1,1.9,0.6,2.4c0.6,0.5,1.2,0.6,1.5,0.6c2.1,0,4.2,0,6.3,0c0.7,0,1.4-0.4,1.6-0.9 c0.3-0.7-0.3-1.8-1.6-2.2C17.7,197,14.9,197,12.2,197z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1mwh",
    d: "M12.6,198.6c-1,0-1.9-0.1-2.9-0.1c-0.2,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1-0.1-1.6c1.3,0,2.6,0,3.9,0 C12.7,197.2,12.7,197.9,12.6,198.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1mwh",
    d: "M21.7,198.8c1,0,1.9-0.1,2.9-0.1c0.2,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0.1-1.6c-1.3,0-2.6,0-3.9,0 C21.6,197.5,21.6,198.2,21.7,198.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0mwh",
    d: "M28.2,188.2H6.4v-9.6h21.8c0,2.7,0,5.3,0,8C28.2,187.1,28.2,187.6,28.2,188.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2mwh",
    d: "M28.5,187.2c0.1,0.3,0.1,0.7,0.1,1.1c0,0.1,0,0.2,0,0.2c-3.6,0.5-7.9,0.8-12.6,0.8c-3.8-0.1-7.3-0.4-10.3-0.8 c0-0.5,0-0.9,0-1.4C13.2,187.2,20.9,187.2,28.5,187.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2mwh",
    d: "M7.1,190.9c-0.1,1.9,0,3.7,0.2,5.4c0.2,0.2,0.5,0.6,1,0.8c0.9,0.5,1.7,0.5,2.1,0.5c4.7,0,9.4,0,14.1,0 c0.2,0,1.9-0.1,2.8-1.5c0.6-0.9,0.4-1.8,0.4-2c0-1.3,0-2.6,0-3.9c-6.8,0-13.7,0-20.5,0.1C7.1,190.4,7.1,190.7,7.1,190.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3mwh",
    d: "M28,188.2c1,0.3,1.5,1,1.2,1.5c-0.3,0.5-1.1,0.7-1.2,0.7c-3,0.4-6.8,0.7-11.1,0.7c-4.3,0-8-0.3-11-0.7 c-0.1-0.2-0.4-0.6-0.4-1.1c0-0.5,0.2-0.9,0.4-1.1C13.3,188.2,20.6,188.2,28,188.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4mwh",
    d: "M28.5,96.5c0,22.2,0,44.3,0,66.5c0.5,0.1,2.1,0.3,3.8-0.5c2-1,2.6-2.8,2.7-3.1c0-19.5,0-39.1,0-58.6 c-0.1-0.3-0.5-2.6-2.8-3.7C30.6,96.3,29,96.5,28.5,96.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 93.5,
    className: "st5mwh",
    width: 23.5,
    height: 75.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5mwh",
    d: "M7.9,162.1c-1.4,0.3-2.7,0.6-4.1,0.9c-0.4-0.5-1-1.4-1.4-2.5c-0.8-2.2-0.4-4.1-0.2-5.5c0.4-2.6,0-5.2,0.1-7.7 c0.2-4.6,0.5-22,0.9-49.4c1.4-0.4,2.9-0.8,4.3-1.2C7.7,118.5,7.8,140.3,7.9,162.1z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4mwh",
    cx: 26,
    cy: 129.9,
    rx: 2.8,
    ry: 34.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4mwh",
    cx: 19.5,
    cy: 131.3,
    rx: 2.8,
    ry: 34.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4mwh",
    cx: 12.6,
    cy: 130.6,
    rx: 2.8,
    ry: 34.7
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4mwh",
    cx: 7,
    cy: 129.9,
    rx: 1.9,
    ry: 34.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4mwh",
    d: "M3.3,96.5c0,22.2,0,44.3,0,66.5c-0.2,0.1-1.1,0.3-1.9-0.5c-1-1-1.3-2.8-1.3-3.1c0-19.5,0-39.1,0-58.6 c0-0.3,0.2-2.6,1.4-3.7C2.2,96.3,3,96.5,3.3,96.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3mwh",
    d: "M4.4,167.1c-0.7-0.2-1.2-0.8-1-1.4c0.1-0.4,0.5-0.8,1-0.9c3.4,0.5,7.4,0.9,11.8,1c5.2,0.1,9.9-0.3,13.8-0.8 c0.5,0.3,0.7,0.8,0.7,1.3c-0.1,0.6-0.6,0.9-0.7,0.9c-3.7,0.5-8.2,0.9-13.2,0.8C12.1,168.1,8,167.7,4.4,167.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3mwh",
    d: "M29.7,166.5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6mwh",
    d: "M29.4,166.6c-1,0.6-2,1.1-3,1.7c1.4,0,2.9,0,4.3,0c0,2,0,4.1,0,6.1c-3.8,1.9-7.5,3.8-11.3,5.7 c-4.4-0.1-8.8-0.2-13.2-0.3c0-0.8,0-1.5,0-2.3c-0.9-1.1-1.8-2.1-2.8-3.2c0-2.8,0-5.5,0-8.3C12.1,166.2,20.8,166.4,29.4,166.6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 77.3,
    className: "st7",
    width: 21.5,
    height: 17.9
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7mwh",
    cx: 18.1,
    cy: 79.6,
    rx: 15,
    ry: 2.3
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7mwh",
    cx: 18.1,
    cy: 84.1,
    rx: 15,
    ry: 2.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7mwh",
    cx: 17.9,
    cy: 88.7,
    rx: 15,
    ry: 2.3
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st7mwh",
    cx: 18.2,
    cy: 92.9,
    rx: 15,
    ry: 2.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8mwh",
    d: "M4.6,65.6c-0.5,1.7-1,3-1.3,4c-1.6,4.9-2.4,6.9-1.3,8c0.3,0.4,0.8,0.5,1,0.6c6.9,0,13.7,0,20.6,0 c-1.6-4.9-3.2-9.7-4.7-14.6C14.2,64.3,9.4,64.9,4.6,65.6z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 35.6,
    className: "st9mwh",
    width: 25.3,
    height: 36.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7mwh",
    d: "M1.5,36.8c0-3.3,0-6.5,0-9.8c0.4-0.4,0.8-0.7,1.3-1.1c1.7-1.2,3.4-1.8,4.7-2.1c2.5,0.9,5,1.9,7.5,2.8 c3.4,3.4,6.8,6.7,10.2,10.1C17.2,36.8,9.4,36.8,1.5,36.8z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 39,
    className: "st7mwh",
    width: 11.5,
    height: 22.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.3,
    y: 39.1,
    className: "st7mwh",
    width: 5.7,
    height: 22.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.8,
    y: 40,
    className: "st7mwh",
    width: 1.5,
    height: 21.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st10mwh",
    d: "M9.8,23.5c0.4-0.6,0.9-1.1,1.3-1.7c2.3,0,4.6-0.1,6.8-0.1c3.5,1.7,6.9,3.3,10.4,5c0.9,4.4,1.8,8.7,2.7,13.1 c-0.2,11.1-0.4,22.2-0.6,33.3c0.7,0.3,1.4,0.5,2.2,0.8c0,1.1,0,2.2,0,3.2c0,0.3,0,0.5-0.1,0.6c-0.3,0.6-1.4,0.8-2.6,0.4 c-6.1,0-12.1,0-18.2,0c-0.4-0.6-0.8-1.2-1.2-1.8c0.8,0.2,1.6,0.3,2.4,0.5c3.1,0,6.1,0,9.2,0c0-1.5,0-3,0-4.4c-1,0.3-2,0.6-3,0.9 c-2.8,0-5.7,0.1-8.5,0.1c0.7-1.1,1-2.1,1.1-2.7c0.4-1.6,0.1-2.9,1.2-3.9c0.3-0.2,0.5-0.4,0.7-0.5c2.5-0.1,5.1-0.2,7.6-0.2 c0-1.6,0.1-3.3,0.1-4.9c1,0,2.1,0,3.1,0c0,1.6,0,3.3,0,4.9c0.8,1.9,1.6,3.9,2.4,5.8c0-10.9,0-21.8,0-32.7c-1.1-2.3-3.2-6-7.2-9.6 C15.9,26.4,12.2,24.6,9.8,23.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st11mwh",
    d: "M2.3,24.3c-0.2-0.4-0.2-0.7-0.2-1c2.6,0,5.1-0.1,7.7-0.1c1.7,0.5,4,1.4,6.4,2.9c1.5,0.9,3.8,2.3,6,4.8 c2.8,3.1,4,6.3,4.5,8.6c-1.9-2.9-5.3-7-10.7-10.6c-2.8-1.9-5.5-3.1-7.9-4c-1.5,0.3-3,0.6-4.5,0.9C3.4,25.5,2.7,25.1,2.3,24.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st12mwh",
    d: "M32.5,23.4c0,16.9,0,33.8,0,50.7c-0.7,0-1.5,0-2.2,0c-0.1,0-0.5-0.1-0.8-0.4c-0.5-0.4-0.4-1.1-0.4-1.2 c0.1-1,0.1-15.6,0-35.8c-0.4-1.9-1.5-5.7-5.1-9.4c-2.7-2.8-5.6-4.3-7.5-5.1c5.1,0,10.3,0,15.4,0C32.2,22.7,32.3,23.1,32.5,23.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st11mwh",
    d: "M1.9,23.5c0.3-3.7,1.2-8.1,3.3-12.8C5.8,9.4,6.4,8.2,7,7C13.7,7,20.3,7,27,7c0.8,1.3,1.6,2.7,2.4,4.2 c2.2,4.6,2.9,8.9,3.1,12.2C22.3,23.5,12.1,23.5,1.9,23.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st13mwh",
    d: "M10.3,0C9.8,0.6,9.2,1.3,8.7,1.9c5.5,0,11-0.1,16.5-0.1c-0.4-0.6-0.7-1.2-1.1-1.8C19.5,0,14.9,0,10.3,0z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14mwh",
    d: "M28.7,4.1c-7.7,0-15.3,0-23,0C5.9,3.4,6,2.6,6.2,1.9c7.4,0,14.9-0.1,22.3-0.1C28.5,2.5,28.6,3.3,28.7,4.1z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.7,
    y: 4,
    className: "st14mwh",
    width: 20.9,
    height: 3.9
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st15mwh",
    cx: 8.7,
    cy: 5.9,
    rx: 0.7,
    ry: 0.9
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st15mwh",
    cx: 13.4,
    cy: 5.9,
    rx: 1.2,
    ry: 1.1
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st15mwh",
    cx: 18.5,
    cy: 5.9,
    rx: 1.2,
    ry: 1.1
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st15mwh",
    cx: 23.5,
    cy: 5.9,
    rx: 0.7,
    ry: 0.9
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st15mwh",
    cx: 26.9,
    cy: 5.9,
    rx: 0.5,
    ry: 0.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st16mwh",
    cx: 24.5,
    cy: 175.9,
    r: 6.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st17mwh",
    cx: 25.4,
    cy: 176.4,
    r: 5.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st8mwh",
    cx: 25.6,
    cy: 176.4,
    r: 1.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaceHilt);
export default __webpack_public_path__ + "static/media/mace-hilt.edc92326.svg";
export { ForwardRef as ReactComponent };